// extracted by mini-css-extract-plugin
export default {"icon":"StatusProgressIcon_icon__PVnqC"};